/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { MaterialUiIcon } from '../../icon';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Test';
export const filterTitle = t`Service Test`;
export const entityType = ENTITY_TYPES.TEST;

export function useTest() {
    return useEntity(filterId);
}

export function useTestName() {
    return useEntityName(filterId);
}

const columns = [
    {
        type: COLUMN_TYPES.ICON,
        title: 'Type',
        width: 65,
        icons: [
            {
                getIcon: (row) => <MaterialUiIcon icon={row?.typeNode?.details?.icon} />,
            },
        ],
    },
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
    },
];

function TestFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

TestFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

TestFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/test-detail',
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
        maxWidth: 'sm',
        fullWidth: true, // TODO: something going on with DataTable makes this necessary for full 'sm' size
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(TestFilter);
